import { useStatsigClient, useStatsigUser } from '@statsig/react-bindings'
import {
  RESPONSIVE_BREAKPOINTS_V2,
  RESPONSIVE_BREAKPOINTS_V2_ROLLOUT
} from 'constants/featureFlags'
import { RESPONSIVE_V2_CAPABLE_PAGES } from 'constants/responsiveBreakpoints'
import { RESPONSIVE_BREAKPOINT_VERSIONS } from 'contexts/ResponsiveBreakpointsContext'
import useToken from 'utils/hooks/useToken'

export const RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS = Object.freeze({
  PENDING: 'pending',
  ...RESPONSIVE_BREAKPOINT_VERSIONS
})

const useResponsiveBreakpointsRollout = (page) => {
  const {
    checkGate,
    getDynamicConfig,
    isLoading: isStatsigLoading
  } = useStatsigClient()
  const { user: statsigUser } = useStatsigUser()
  const { getUser } = useToken()
  const authenticatedUser = getUser()
  const expectedUserID = authenticatedUser?.playerid?.toString()
  const expectedEmail = authenticatedUser?.email || undefined
  const statsigUserID = statsigUser?.userID?.toString()
  const statsigEmail = statsigUser?.email || undefined

  if (!RESPONSIVE_V2_CAPABLE_PAGES.includes(page)) {
    return RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.LEGACY
  }

  const isAuthenticatedUserSyncPending = Boolean(
    expectedUserID &&
      (statsigUserID !== expectedUserID || statsigEmail !== expectedEmail)
  )

  if (isStatsigLoading || isAuthenticatedUserSyncPending) {
    return RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.PENDING
  }

  try {
    if (!checkGate(RESPONSIVE_BREAKPOINTS_V2)) {
      return RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.LEGACY
    }

    const rollout = getDynamicConfig(RESPONSIVE_BREAKPOINTS_V2_ROLLOUT)
    const enabledPages = rollout.get('pages', [])

    return Array.isArray(enabledPages) && enabledPages.includes(page)
      ? RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.V2
      : RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.LEGACY
  } catch {
    return RESPONSIVE_BREAKPOINT_ROLLOUT_STATUS.LEGACY
  }
}

export default useResponsiveBreakpointsRollout
